// Resolves a gallery image's display (thumbnail) URL from the gallery state.
// Used to show the actual input image behind processing job cards instead of a
// static placeholder. Falls back to the first pixel image if no Thumbnail exists.
export function imageThumbUri(galleryImages, logicalImageId) {
  if (!logicalImageId) return null;
  const image = galleryImages?.data?.find(
    (img) => img.logicalImageId === logicalImageId
  );
  if (!image?.pixelImages?.length) return null;
  const thumb = image.pixelImages.find((p) => p.type === "Thumbnail");
  return thumb?.uri ?? image.pixelImages[0].uri ?? null;
}
